import { useState, useCallback } from 'react';
import { UploadStep, UploadProgressState } from '../components/bulletins/UploadProgressModal';

export const useUploadProgress = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [progressState, setProgressState] = useState<UploadProgressState>({
    step: 'validating',
    progress: 0,
    message: '',
    canCancel: true
  });

  const startUpload = useCallback(() => {
    setProgressState({
      step: 'validating',
      progress: 0,
      message: 'Validating your post...',
      canCancel: true
    });
    setIsModalOpen(true);
  }, []);

  const updateProgress = useCallback((
    step: UploadStep,
    progress: number,
    message?: string,
    options?: {
      canCancel?: boolean;
      error?: string;
      estimatedTimeRemaining?: number;
    }
  ) => {
    setProgressState(prev => ({
      ...prev,
      step,
      progress,
      message: message || prev.message,
      canCancel: options?.canCancel ?? prev.canCancel,
      error: options?.error,
      estimatedTimeRemaining: options?.estimatedTimeRemaining
    }));
  }, []);

  const setError = useCallback((error: string) => {
    setProgressState(prev => ({
      ...prev,
      step: 'error',
      error,
      canCancel: true
    }));
  }, []);

  const setComplete = useCallback(() => {
    setProgressState(prev => ({
      ...prev,
      step: 'complete',
      progress: 100,
      message: 'Post successful!',
      canCancel: true
    }));
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const resetProgress = useCallback(() => {
    setProgressState({
      step: 'validating',
      progress: 0,
      message: '',
      canCancel: true
    });
    setIsModalOpen(false);
  }, []);

  return {
    isModalOpen,
    progressState,
    startUpload,
    updateProgress,
    setError,
    setComplete,
    closeModal,
    resetProgress
  };
};